import { InputHamburger } from './InputHamburger';
import { InputPreview } from './InputPreview';
import { InputDragPreview } from './InputDragPreview';

export const InputHelper = {
  Hamburger: InputHamburger,
  Preview: InputPreview,
  DragPreview: InputDragPreview,
};
